import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(handleTopicChannel);

import { eventChannel } from 'redux-saga';
import { cancelled, race, take, put, call, cancel, fork, select, takeEvery } from 'redux-saga/effects';
import { socket } from '../../apis/socket';
import { fetchDiscussion, fetchMessages, sendMessage, updateMessage } from '../../apis/discussions';
import { regSaga } from '../../store';
import { ADD_DISCUSSION, JOIN_DISCUSSION, LEAVE_DISCUSSION, SET_DISCUSSION_ERROR, FETCH_MORE_MESSAGES, SEND_MESSAGE, SEND_MESSAGE_UPDATE, SET_MORE_MESSAGES, SET_TOPIC_STATUS, UPDATE_PRESENCE, UPDATE_DISCUSSION, ADD_MESSAGE, MESSAGE_UPDATE, REMOVE_MESSAGE, ADD_PARTICIPANT, REMOVE_PARTICIPANT, UPDATE_PARTICIPANT, ADD_INVITATION, REMOVE_INVITATION, UPDATE_INVITATION, UNSUBSCRIBED } from './redux';
export function registerTopicChannel(topic) {
  return eventChannel(function (emit) {
    topic.onPresence(function (op, presenceData) {
      emit({
        event: 'presence',
        payload: {
          op: op,
          presenceData: presenceData
        }
      });
    }).onStatus(function (status) {
      return emit({
        event: 'status',
        payload: status
      });
    }).on('message:created', emit).on('message:updated', emit).on('message:deleted', emit).on('participant:created', emit).on('participant:updated', emit).on('participant:deleted', emit).on('invitation:created', emit).on('invitation:updated', emit).on('invitation:deleted', emit).on('relatedItem:created', emit).on('relatedItem:deleted', emit).on('discussion:updated', emit).on('discussion:deleted', emit).on('unsubscribed', emit);
    return function () {
      return topic.unsubscribe();
    };
  });
}
export function handleTopicChannel(channel, id, socket, topic) {
  var topicEvent;
  return _regeneratorRuntime.wrap(function handleTopicChannel$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;

        case 1:
          if (!true) {
            _context.next = 50;
            break;
          }

          _context.next = 4;
          return take(channel);

        case 4:
          topicEvent = _context.sent;
          _context.t0 = topicEvent.event;
          _context.next = _context.t0 === 'status' ? 8 : _context.t0 === 'presence' ? 11 : _context.t0 === 'discussion:updated' ? 14 : _context.t0 === 'message:created' ? 17 : _context.t0 === 'message:updated' ? 20 : _context.t0 === 'message:deleted' ? 23 : _context.t0 === 'participant:created' ? 26 : _context.t0 === 'participant:deleted' ? 29 : _context.t0 === 'participant:updated' ? 32 : _context.t0 === 'invitation:created' ? 35 : _context.t0 === 'invitation:deleted' ? 38 : _context.t0 === 'invitation:updated' ? 41 : _context.t0 === 'unsubscribed' ? 44 : 47;
          break;

        case 8:
          _context.next = 10;
          return put({
            type: SET_TOPIC_STATUS,
            payload: {
              id: id,
              status: topicEvent.payload
            }
          });

        case 10:
          return _context.abrupt("break", 48);

        case 11:
          _context.next = 13;
          return put({
            type: UPDATE_PRESENCE,
            payload: {
              id: id,
              presences: topic.presence()
            }
          });

        case 13:
          return _context.abrupt("break", 48);

        case 14:
          _context.next = 16;
          return put({
            type: UPDATE_DISCUSSION,
            payload: topicEvent.payload
          });

        case 16:
          return _context.abrupt("break", 48);

        case 17:
          _context.next = 19;
          return put({
            type: ADD_MESSAGE,
            payload: {
              id: id,
              message: topicEvent.payload
            }
          });

        case 19:
          return _context.abrupt("break", 48);

        case 20:
          _context.next = 22;
          return put({
            type: MESSAGE_UPDATE,
            payload: {
              id: id,
              message: topicEvent.payload
            }
          });

        case 22:
          return _context.abrupt("break", 48);

        case 23:
          _context.next = 25;
          return put({
            type: REMOVE_MESSAGE,
            payload: {
              id: id,
              message: topicEvent.payload
            }
          });

        case 25:
          return _context.abrupt("break", 48);

        case 26:
          _context.next = 28;
          return put({
            type: ADD_PARTICIPANT,
            payload: {
              id: id,
              participant: topicEvent.payload
            }
          });

        case 28:
          return _context.abrupt("break", 48);

        case 29:
          _context.next = 31;
          return put({
            type: REMOVE_PARTICIPANT,
            payload: {
              id: id,
              participant: topicEvent.payload
            }
          });

        case 31:
          return _context.abrupt("break", 48);

        case 32:
          _context.next = 34;
          return put({
            type: UPDATE_PARTICIPANT,
            payload: {
              id: id,
              participant: topicEvent.payload
            }
          });

        case 34:
          return _context.abrupt("break", 48);

        case 35:
          _context.next = 37;
          return put({
            type: ADD_INVITATION,
            payload: {
              id: id,
              invitation: topicEvent.payload
            }
          });

        case 37:
          return _context.abrupt("break", 48);

        case 38:
          _context.next = 40;
          return put({
            type: REMOVE_INVITATION,
            payload: {
              id: id,
              invitation: topicEvent.payload
            }
          });

        case 40:
          return _context.abrupt("break", 48);

        case 41:
          _context.next = 43;
          return put({
            type: UPDATE_INVITATION,
            payload: {
              id: id,
              invitation: topicEvent.payload
            }
          });

        case 43:
          return _context.abrupt("break", 48);

        case 44:
          _context.next = 46;
          return put({
            type: UNSUBSCRIBED,
            payload: {
              id: id
            }
          });

        case 46:
          return _context.abrupt("break", 48);

        case 47:
          console.log("Unhandled socket action '".concat(topicEvent.event, "' for ").concat(id, ": "), topicEvent);

        case 48:
          _context.next = 1;
          break;

        case 50:
          _context.prev = 50;
          _context.next = 53;
          return cancelled();

        case 53:
          if (!_context.sent) {
            _context.next = 56;
            break;
          }

          _context.next = 56;
          return channel.close();

        case 56:
          return _context.finish(50);

        case 57:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0,, 50, 57]]);
}

var selectMessageToken = function selectMessageToken(discussionId) {
  return function (state) {
    return state.getIn(['discussions', discussionId, 'nextPageToken']);
  };
};

regSaga(takeEvery(SEND_MESSAGE, /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
  return _regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return call(sendMessage, action.payload);

        case 3:
          _context2.next = 8;
          break;

        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _callee, null, [[0, 5]]);
})));
regSaga(takeEvery(SEND_MESSAGE_UPDATE, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(action) {
  return _regeneratorRuntime.wrap(function _callee2$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return call(updateMessage, action.payload);

        case 3:
          _context3.next = 8;
          break;

        case 5:
          _context3.prev = 5;
          _context3.t0 = _context3["catch"](0);
          console.error(_context3.t0);

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _callee2, null, [[0, 5]]);
})));
regSaga(takeEvery(FETCH_MORE_MESSAGES, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(action) {
  var pageToken, _yield$call, messages, nextPageToken;

  return _regeneratorRuntime.wrap(function _callee3$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return select(selectMessageToken(action.payload));

        case 3:
          pageToken = _context4.sent;
          _context4.next = 6;
          return call(fetchMessages, action.payload, pageToken);

        case 6:
          _yield$call = _context4.sent;
          messages = _yield$call.messages;
          nextPageToken = _yield$call.nextPageToken;
          _context4.next = 11;
          return put({
            type: SET_MORE_MESSAGES,
            payload: {
              id: action.payload,
              messages: messages,
              nextPageToken: nextPageToken
            }
          });

        case 11:
          _context4.next = 16;
          break;

        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](0);
          console.error(_context4.t0);

        case 16:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee3, null, [[0, 13]]);
})));
regSaga('WATCH_DISCUSSIONS_SOCKET', /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
  var discussionTasks, _loop;

  return _regeneratorRuntime.wrap(function _callee4$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          discussionTasks = [];
          _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
            var _yield$race, joinTopic, leaveTopic, topicId, topic, channel, handler, _yield$call2, discussion, error, discussionTask;

            return _regeneratorRuntime.wrap(function _loop$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return race({
                      joinTopic: take(JOIN_DISCUSSION),
                      leaveTopic: take(LEAVE_DISCUSSION)
                    });

                  case 2:
                    _yield$race = _context5.sent;
                    joinTopic = _yield$race.joinTopic;
                    leaveTopic = _yield$race.leaveTopic;

                    if (!joinTopic) {
                      _context5.next = 33;
                      break;
                    }

                    _context5.prev = 6;
                    topicId = "discussions/discussion/".concat(joinTopic.payload.id);
                    topic = socket.topic(topicId);
                    channel = registerTopicChannel(topic);
                    _context5.next = 12;
                    return fork(handleTopicChannel, channel, joinTopic.payload.id, socket, topic);

                  case 12:
                    handler = _context5.sent;
                    discussionTasks.push({
                      id: joinTopic.payload.id,
                      topic: topic,
                      channel: channel,
                      handler: handler
                    });
                    _context5.next = 16;
                    return call(topic.subscribe.bind(topic), joinTopic.payload.invitationToken);

                  case 16:
                    _context5.next = 18;
                    return call(fetchDiscussion, {
                      id: joinTopic.payload.id
                    });

                  case 18:
                    _yield$call2 = _context5.sent;
                    discussion = _yield$call2.discussion;
                    error = _yield$call2.error;

                    if (!error) {
                      _context5.next = 25;
                      break;
                    }

                    console.error('Failed to join discussion!');
                    _context5.next = 27;
                    break;

                  case 25:
                    _context5.next = 27;
                    return put({
                      type: ADD_DISCUSSION,
                      payload: discussion
                    });

                  case 27:
                    _context5.next = 33;
                    break;

                  case 29:
                    _context5.prev = 29;
                    _context5.t0 = _context5["catch"](6);
                    _context5.next = 33;
                    return put({
                      type: SET_DISCUSSION_ERROR,
                      payload: {
                        id: joinTopic.payload.id,
                        error: _context5.t0.payload
                      }
                    });

                  case 33:
                    if (!leaveTopic) {
                      _context5.next = 44;
                      break;
                    }

                    _context5.prev = 34;
                    // Fetch the task.
                    discussionTask = discussionTasks.find(function (dt) {
                      return dt.id === leaveTopic.payload;
                    }); // Ask the channel to close the socket.

                    _context5.next = 38;
                    return cancel(discussionTask.handler);

                  case 38:
                    // Remove the task from the queue.
                    discussionTasks = discussionTasks.filter(function (dt) {
                      return dt.id !== discussionTask.id;
                    });
                    _context5.next = 44;
                    break;

                  case 41:
                    _context5.prev = 41;
                    _context5.t1 = _context5["catch"](34);
                    console.warn('There was a problem leaving a discussion topic:', _context5.t1);

                  case 44:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _loop, null, [[6, 29], [34, 41]]);
          });

        case 2:
          if (!true) {
            _context6.next = 6;
            break;
          }

          return _context6.delegateYield(_loop(), "t0", 4);

        case 4:
          _context6.next = 2;
          break;

        case 6:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee4);
}));